import {ResolutionStatus, TransactionCategory, TransactionType} from '@npck/af-frontend-api';
import dayjs from 'dayjs';

export const DESCRIPTION_MAX_LENGTH = 2000;
export const DESCRIPTION_MIN_LENGTH = 10;
export const REJECT_COMMENT_MAX_LENGTH = 2000;
export const PAYMENT_POINT_MAX_LENGTH = 34;
export const IBAN_MAX_LENGTH = 34;
export const KZ_IBAN_LENGTH = 20;
export const FOREIGN_IBAN_MIN_LENGTH = 15;
export const KZ_IBAN_PATTERN = /^KZ[0-9]{5}[A-Z0-9]{13}$/;
export const FOREIGN_IBAN_PATTERN = /^(?!KZ)[A-Z]{2}[0-9]{2}[A-Z0-9]+$/;
export const SUPPORT_EMAIL = 'Support.anti-fraud@npck.kz';
export const LAST_ALLOWED_DAYS_LEFT = 1;
export const PASSWORD_EXPIRY_WARNING_DAYS = 7;
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 255;
export const PASSWORD_ALLOWED_CHAR_CLASS = '[\\x21-\\x39\\x3C-\\x7E]';
export const PASSWORD_SPECIAL_CHAR_CLASS = '[\\x21-\\x2F\\x3C-\\x40\\x5B-\\x60\\x7B-\\x7E]';
export const PASSWORD_PATTERN =
    `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*${PASSWORD_SPECIAL_CHAR_CLASS})${PASSWORD_ALLOWED_CHAR_CLASS}` +
    `{${PASSWORD_MIN_LENGTH},${PASSWORD_MAX_LENGTH}}$`;
export const NUMBER_PATTERN = '^[0-9A-Za-z@_.+/:-]+$';
export const CARD_NUMBER_MAX_LENGTH = 20;
export const CARD_NUMBER_MIN_LENGTH = 16;
export const WALLET_NUMBER_MAX_LENGTH = 20;
export const WALLET_NUMBER_MIN_LENGTH = 11;
export const MAX_FILES_COUNT = 10;
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/tiff',
    'image/bmp',
    'image/png',
];
export const KB_MIME_TYPES = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
export const ORGANIZATION_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/tiff',
    'image/bmp',
    'image/png',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
export const CACHE_EXPIRATION_INTERVAL = 20;
export const MAX_PAYMENT_POINT_NUMBER = 34;
export const PATTERN_PAYMENT_POINT_NUMBER = /^[A-Z0-9 ]*$/;
export const MERCHANT_NAME_PATTERN = /^(?=.*\p{L})[\p{Script=Latin}\p{Script=Cyrillic}0-9 \-.,'&()]+$/u;
export const MERCHANT_IDENTIFIER_PATTERN = /^[A-Za-z0-9_-]+$/;
export const MIN_DATE = dayjs('2024-07-22').toDate();
export const KZT_CURRENCY_CODE = '398';
export const NESTED_NESTED_TAB = 'nested-nested-tab';
export const UNIFIED_REGISTER_MAX_LENGTH = 15;
export const UNIFIED_REGISTER_PATTERN = new RegExp(`^\\d{${UNIFIED_REGISTER_MAX_LENGTH}}$`);
export const INNOCENT_RESOLUTION_STATUSES = [ResolutionStatus.NF, ResolutionStatus.NOT_CONFIRMED];
export const TRANSFER_CATEGORY_CODE = TransactionCategory.P;
export const REFUND_TRANSFER_TYPE_CODES = [TransactionType.A2A, TransactionType.CORPA2A];
